import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useReadTopicType} from "./useReadTopicType";
import {readFaqApi} from "../../../../api/support/faq";
import {ReadFaqApiProps} from "../../../../types/support/faq";

/**
 * FAQ 목록 hook
 * @returns
 */
export const useReadFaq = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const buildQuery = (searchParam: any) => {
        let query = `?keywordType=${searchParam.keywordType}&keyword=${searchParam.keyword}&pageNo=1`;
        if (searchParam.topicTypeList.length > 0) {
            query += `&topicTypeList=${searchParam.topicTypeList.join(",")}`;
        }
        return query;
    }
    const {data: topicTypeData} = useReadTopicType();
    const queryStringParam = {
        keyword: searchParams?.get("keyword") || '',
        keywordType: Number(searchParams?.get("keywordType")) || 0,
        pageNo: Number(searchParams?.get("pageNo")) || 1,
        limit: 10,
        topicTypeList: searchParams?.get("topicTypeList")?.split(',') || []
    }
    const [searchParam, setSearchParam] = useState(queryStringParam)

    const res = useQuery({
        queryKey: ["readFaqApi", queryStringParam],
        queryFn: async () => await readFaqApi(queryStringParam as ReadFaqApiProps),
        // staleTime: 6000 * 10,
        select: (res) => res?.result
    });

    useEffect(() => {
        setSearchParam({
            ...queryStringParam,
            topicTypeList: (topicTypeData?.map((item: any) => item.codeEntriesName) || []) as string[]
        });
    }, [topicTypeData]);


    const search = () => {
        navigate(buildQuery({
            ...searchParam,
            keywordType: searchParam.keywordType === 0 ? 1 : searchParam.keywordType
        }));
    }

    const addRemoveTopicType = (topicType: string) => {
        if (searchParam.topicTypeList.includes(topicType)) {
            setSearchParam({
                ...searchParam,
                topicTypeList: searchParam.topicTypeList.filter((item) => item !== topicType)
            });
            return;
        } else
            setSearchParam({...searchParam, topicTypeList: [...searchParam.topicTypeList, topicType]});
    }

    return {res, searchParam, setSearchParam, search, addRemoveTopicType};
};
